import React from 'react';
import {CopyToClipboard} from "react-copy-to-clipboard";
import {Box, Button} from "@material-ui/core";
import FileCopyIcon from "@material-ui/icons/FileCopy";

const CopyButton = ({ data, copyText, disableText = false }) => (
    <CopyToClipboard text={data}>
        <Box display="flex" justifyContent={"space-between"} alignItems={"center"}>
            <Button
                variant="contained"
                color="primary"
                startIcon={<FileCopyIcon/>}
            >
                {!disableText ? (
                    <>
                        {copyText ?? 'Copy Raw'}
                    </>
                ) : null}
            </Button>
        </Box>
    </CopyToClipboard>
);

export default CopyButton;